import { Injectable } from "@angular/core";
import { map, mergeMap } from "rxjs/operators";
import { MediaHandlerService } from "../handlers/media-handler.service";
import { AWSService } from "../shared/aws.service";

export interface Media {
  account_id: number;
  aws_key: string;
  context: string;
  created_at: Date;
  created_by: number | null;
  created_by_name: string | null;
  description: string;
  id: number;
  name: string;
  url: string;
}

@Injectable({
  providedIn: "root",
})
export class MediaService {
  constructor(
    private MediaHandlerService: MediaHandlerService,
    private AWSService: AWSService,
  ) {}

  //LIST
  getMedias(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
      [key: string]: any;
    },
  ) {
    return this.MediaHandlerService.getAll(masterAccountID, queryParams);
  }

  postMedia(
    masterAccountID: number,
    file: File,
    context: string,
    description: string,
  ) {
    return this.MediaHandlerService.signUpload(masterAccountID, {
      file: {
        size: file.size,
        name: file.name,
        type: file.type,
      },
      folder: "images",
    }).pipe(
      mergeMap((signedResponse) => {
        return this.AWSService.uploadImage(
          (signedResponse as any).signed_request,
          file,
        ).pipe(
          mergeMap(() => {
            return this.MediaHandlerService.postMedia(masterAccountID, {
              aws_key: (signedResponse as any).aws_key,
              context,
              name: file.name,
              description,
              url: (signedResponse as any).url,
            });
          }),
        );
      }),
    );
  }

  deleteMedia(masterAccountID: number, mediaID: number) {
    return this.MediaHandlerService.deleteMedia(masterAccountID, mediaID);
  }

  updateMedia(masterAccountID: number, media: Media, file?: File) {
    const baseUpdate$ = file
      ? this.MediaHandlerService.signUpload(masterAccountID, {
          file: {
            size: file.size,
            name: file.name,
            type: file.type,
          },
          folder: "images",
        }).pipe(
          mergeMap((signedResponse) =>
            this.AWSService.uploadImage(
              (signedResponse as any).signed_request,
              file,
            ).pipe(
              mergeMap(() =>
                this.MediaHandlerService.putMedia(masterAccountID, {
                  ...media,
                  aws_key: (signedResponse as any).aws_key,
                  url: (signedResponse as any).url,
                  name: file.name,
                }),
              ),
            ),
          ),
        )
      : this.MediaHandlerService.putMedia(masterAccountID, media);

    return baseUpdate$.pipe(map((response: any) => response?.saved ?? response));
  }
}
